var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-wrapper"},[_c('line-chart',{attrs:{"chart-data":_vm.chartdata,"height":200,"options":_vm.options}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }